import type { RouteObject } from "react-router";
import { PurchaseList } from "./PurchaseList";

export const purchaseRoute: RouteObject = {
  path: "purchase",
  element: <PurchaseList />,
};
